import { YDatabase } from '@databases/collab/y-database';
import { fieldTypesNames } from '@databases/intl/field-type-names';
import { messages } from '@databases/intl/messages';
import { NumberSeparator } from '@databases/model/custom-number-format';
import {
  BacklinkDisplayType,
  FieldType,
  NumberFormat,
  ParentPageType,
  ParentPageOption,
} from '@databases/model/field';
import type { IntlShape } from 'react-intl-next';
import { v5 as uuidv5 } from 'uuid';

// FIXME: these should not be required
const defaultFieldSettings = {
  resolve: false,
  multi: false,
  newlines: false,
  allowEdit: true,
  databaseId: undefined,
  displayedDetail: undefined,
  contentField: undefined,
  creatable: undefined,
  fieldId: undefined,
  jiraField: undefined,
  jiraServerId: undefined,
  cloudId: undefined,
  includeVersionComment: undefined,
  backlinkDisplayType: BacklinkDisplayType.AS_NUMBER,
  entryFieldField: undefined,
  pageTemplateId: undefined,
  parentPage: undefined,
  parentPageOption: ParentPageOption.FIXED,
  isParentPageSourceDatabase: undefined,
  displayEntryOnPage: undefined,
  parentPageType: ParentPageType.PAGE,
  parentPageFieldId: undefined,
  numberFormat: NumberFormat.NUMBER,
  customNumberFormat: {
    minFractionDigits: undefined,
    maxFractionDigits: undefined,
    thousandsSeparator: undefined,
    decimalSeparator: NumberSeparator.DOT,
    prefix: undefined,
    suffix: undefined,
  },
  selectOptions: [],
  defaultEnabled: false,
};

const defaultNamespace = '319e34ab-a1c3-45c8-b7b9-6758bb7b7c1d';

/**
 * Adds a default document to the database.
 */
export const initialDoc = {
  version: 1,
  apply(documentId: string, ydb: YDatabase, intl: IntlShape) {
    const documentNamespace = uuidv5(documentId, defaultNamespace);
    const { formatMessage } = intl;

    ydb.mutate(() => {
      if (ydb.fields.length === 0) {
        const mainField = uuidv5('field-1', documentNamespace);
        ydb.addField(mainField, {
          name: formatMessage(
            messages['field-settings.field-name-inline-edit-default-text'],
            {
              defaultFieldName: formatMessage(fieldTypesNames[FieldType.Text]),
            }
          ),
          type: FieldType.Text,
          width: undefined,
          description: '',
          showDescription: false,
          ...defaultFieldSettings,
        });

        ydb.addField(uuidv5('field-2', documentNamespace), {
          name: formatMessage(
            messages['field-settings.field-name-inline-edit-default-text'],
            {
              defaultFieldName: formatMessage(fieldTypesNames[FieldType.Select]),
            }
          ),
          type: FieldType.Select,
          width: undefined,
          description: '',
          showDescription: false,
          ...defaultFieldSettings,
        });

        ydb.addField(uuidv5('field-3', documentNamespace), {
          name: formatMessage(
            messages['field-settings.field-name-inline-edit-default-text'],
            {
              defaultFieldName: formatMessage(fieldTypesNames[FieldType.User]),
            }
          ),
          type: FieldType.User,
          width: undefined,
          description: '',
          showDescription: false,
          ...defaultFieldSettings,
        });
      }

      if (ydb.entries.length === 0) {
        for (let i = 0; i < 3; i++) {
          ydb.addEntry(uuidv5(`entry-${i}`, documentNamespace));
        }
      }
    });
  },
};
